import { BrowserAgent } from '@newrelic/browser-agent';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import config from './config';

const agent = new BrowserAgent({
  loaderConfig: {
    accountID: config.accountID,
    trustKey: config.trustKey,
    agentID: config.agentID,
    licenseKey: config.licenseKey,
    applicationID: config.applicationID,
  },
  info: {
    beacon: 'bam.nr-data.net',
    errorBeacon: 'bam.nr-data.net',
    licenseKey: config.licenseKey,
    applicationID: config.applicationID,
    sa: 1
  },
  init: {
    distributed_tracing: {
      enabled: true
    },
    privacy: {
      cookies_enabled: true
    },
    ajax: {
      deny_list: ['bam.nr-data.net']
    },
    session_replay: {
      enabled: true,
      sampling_rate: 10,
      error_sampling_rate: 100,
      mask_all_inputs: true
    }
  }
});

agent.start();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
